import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_4308373f from 'nuxt_plugin_plugin_4308373f' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_0e262399 from 'nuxt_plugin_sentryserver_0e262399' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_af269bde from 'nuxt_plugin_sentryclient_af269bde' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_toast_737c5584 from 'nuxt_plugin_toast_737c5584' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_templatesplugine5e24030_38223ca2 from 'nuxt_plugin_templatesplugine5e24030_38223ca2' // Source: ./templates.plugin.e5e24030.js (mode: 'client')
import nuxt_plugin_image_db59f460 from 'nuxt_plugin_image_db59f460' // Source: ./image.js (mode: 'all')
import nuxt_plugin_pluginutils_ab26ebf4 from 'nuxt_plugin_pluginutils_ab26ebf4' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_7772add1 from 'nuxt_plugin_pluginrouting_7772add1' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_6b771184 from 'nuxt_plugin_pluginmain_6b771184' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_deviceplugin_304bfb60 from 'nuxt_plugin_deviceplugin_304bfb60' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_prismic_ec79d35a from 'nuxt_plugin_prismic_ec79d35a' // Source: ./prismic/plugins/prismic.js (mode: 'all')
import nuxt_plugin_prismiccomponents_43f94b90 from 'nuxt_plugin_prismiccomponents_43f94b90' // Source: ./prismic/plugins/prismic-components.js (mode: 'all')
import nuxt_plugin_dynamicobjectposition_2e0996e4 from 'nuxt_plugin_dynamicobjectposition_2e0996e4' // Source: ../../../plugins/dynamic-object-position.js (mode: 'all')
import nuxt_plugin_clickaway_0a91e480 from 'nuxt_plugin_clickaway_0a91e480' // Source: ../../../plugins/clickaway (mode: 'all')
import nuxt_plugin_vuegtag_9dc199a0 from 'nuxt_plugin_vuegtag_9dc199a0' // Source: ../../../plugins/vue-gtag (mode: 'client')
import nuxt_plugin_veevalidate_1a0c1998 from 'nuxt_plugin_veevalidate_1a0c1998' // Source: ../../../plugins/vee-validate.js (mode: 'all')
import nuxt_plugin_superlogin_a4447f96 from 'nuxt_plugin_superlogin_a4447f96' // Source: ../../../plugins/superlogin.client (mode: 'client')
import nuxt_plugin_mixpanel_98f97ac4 from 'nuxt_plugin_mixpanel_98f97ac4' // Source: ../../../plugins/mixpanel (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: function() {
    const i18nHead = { htmlAttrs: [], meta: [], link: [] };

    return {
      title: 'ATHLYZER | Videoanalyse',
      htmlAttrs: {
        ...i18nHead.htmlAttrs
      },
      meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      {
        hid: 'description',
        name: 'description',
        content:
        'Deine cloud-basierte Videoanalyse Software für Fußball, Hockey, Eishockey und viele mehr. Verfügbar auf MacOS, Windows, iOS und Android. Starte jetzt ab 28€ p.M.'
      },
      { hid: 'og-type', property: 'og:type', content: 'website' },
      {
        hid: 'og-title',
        property: 'og:title',
        content: 'Videoanalyse-Software | ATHLYZER'
      },
      {
        hid: 'og-desc',
        property: 'og:description',
        content:
        'Deine cloud-basierte Videoanalyse Software für Fußball, Hockey, Eishockey und viele mehr. Verfügbar auf MacOS, Windows, iOS und Android. Starte jetzt ab 28€ p.M.'
      },
      {
        hid: 'og-image',
        property: 'og:image',
        content: '/ATHLYZER_OG.jpg'
      },
      { hid: 't-type', name: 'twitter:card', content: 'summary_large_image' },
      { name: 'format-detection', content: 'telephone=no' },
      ...i18nHead.meta],

      link: [
      { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' },
      ...i18nHead.link],

      script: [
      {
        hid: 'cookie',
        id: 'cookie-banner',
        type: 'module',
        src: 'https://unpkg.com/@porscheofficial/cookie-consent-banner@3.0.0/dist/cookie-consent-banner/cookie-consent-banner.esm.js'
      }]
    };
  },

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_4308373f === 'function') {
    await nuxt_plugin_plugin_4308373f(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_0e262399 === 'function') {
    await nuxt_plugin_sentryserver_0e262399(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_af269bde === 'function') {
    await nuxt_plugin_sentryclient_af269bde(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_737c5584 === 'function') {
    await nuxt_plugin_toast_737c5584(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugine5e24030_38223ca2 === 'function') {
    await nuxt_plugin_templatesplugine5e24030_38223ca2(app.context, inject)
  }

  if (typeof nuxt_plugin_image_db59f460 === 'function') {
    await nuxt_plugin_image_db59f460(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_ab26ebf4 === 'function') {
    await nuxt_plugin_pluginutils_ab26ebf4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_7772add1 === 'function') {
    await nuxt_plugin_pluginrouting_7772add1(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_6b771184 === 'function') {
    await nuxt_plugin_pluginmain_6b771184(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_304bfb60 === 'function') {
    await nuxt_plugin_deviceplugin_304bfb60(app.context, inject)
  }

  if (typeof nuxt_plugin_prismic_ec79d35a === 'function') {
    await nuxt_plugin_prismic_ec79d35a(app.context, inject)
  }

  if (typeof nuxt_plugin_prismiccomponents_43f94b90 === 'function') {
    await nuxt_plugin_prismiccomponents_43f94b90(app.context, inject)
  }

  if (typeof nuxt_plugin_dynamicobjectposition_2e0996e4 === 'function') {
    await nuxt_plugin_dynamicobjectposition_2e0996e4(app.context, inject)
  }

  if (typeof nuxt_plugin_clickaway_0a91e480 === 'function') {
    await nuxt_plugin_clickaway_0a91e480(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuegtag_9dc199a0 === 'function') {
    await nuxt_plugin_vuegtag_9dc199a0(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_1a0c1998 === 'function') {
    await nuxt_plugin_veevalidate_1a0c1998(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_superlogin_a4447f96 === 'function') {
    await nuxt_plugin_superlogin_a4447f96(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mixpanel_98f97ac4 === 'function') {
    await nuxt_plugin_mixpanel_98f97ac4(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
